export const INTERCOM_WIDGET_CLASSNAME = 'open-intercom-messenger';
